<template>
  <div class="company-badge" :class="badgeTheme">
    <div class="badge-wrapper" v-show="badgeReady">
      <div class="badge-progress">
        <svg id="progress" width="64" height="64" viewBox="0 0 100 100">
          <circle class="progress__meter" cx="50%" cy="50%" r="38" stroke-width="5" />
          <circle class="progress__value progress__value-ft" cx="50" cy="50" r="38" stroke-width="5" />
          <circle class="progress__value progress__value-pp" cx="50" cy="50" r="38" stroke-width="5" />
          <circle class="progress__value progress__value-at" cx="50" cy="50" r="38" stroke-width="5" />
          <circle class="progress__value progress__value-rt" cx="50" cy="50" r="38" stroke-width="5" />
        </svg>
      </div>
      <div class="badge-text">
        <div class="logo"></div>
        <div class="level"
             v-bind:style="{ backgroundColor: getCompanyLevel('color') }">
          {{ this.getCompanyLevel('name') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'badge',
    data () {
      return {
        companyId: null,
        companyPoints: null,
        companyAverage: 0,
        badgeTheme: null,
        badgeReady: false
      }
    },
    methods: {
      getCompany () {
        this.$http.get(api.URLS.companyPublic + '/' + this.companyId, api.headersAuthSettings).then((res) => {
          this.companyPoints = res.body
          let total = 0
          for (let index in this.companyPoints) {
            let quarter = this.companyPoints[index]
            this.setCompanyProgress(quarter, index)
            total += quarter
          }
          this.companyAverage = total / 4
          this.badgeReady = true
        })
      },
      getCompanyLevel (returnThis) {
        let score = this.companyAverage
        let level
        if (score >= 0) {
          level = {
            name: 'Foundation',
            color: '#97eedd'
          }
        }
        if (score > 19) {
          level = {
            name: 'Bronze',
            color: '#ffdbb4'
          }
        }
        if (score > 39) {
          level = {
            name: 'Silver',
            color: '#e8e8e8'
          }
        }
        if (score > 59) {
          level = {
            name: 'Gold',
            color: '#ffe993'
          }
        }
        if (score > 79) {
          level = {
            name: 'Platinum',
            color: '#7fdce8'
          }
        }
        return level[returnThis]
      },
      setCompanyProgress (value, index) {
        let RADIUS = 38
        let CIRCUMFERENCE = 2 * Math.PI * RADIUS
        let progressValue = document.querySelector('.progress__value' + '-' + index)
        let progress = (value / 100) / 4
        progressValue.style.display = 'block'
        progressValue.style.strokeDasharray = CIRCUMFERENCE
        progressValue.style.strokeDashoffset = CIRCUMFERENCE * (1 - progress)
      },
      getUrlParameter (name) {
        name = name.replace(/[/]/, '\\[').replace(/[\]]/, '\\]')
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
        var results = regex.exec(location.search)
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
      }
    },
    beforeDestroy () {
      document.body.classList.remove('hide-cookie-accept')
    },
    created () {
      this.companyId = this.getUrlParameter('company')
      this.badgeTheme = this.getUrlParameter('theme')
      this.getCompany()
      document.body.classList.add('hide-cookie-accept')
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/components/fonts.css';
  @import '../../assets/scss/settings/settings';
  .badge {
    &-wrapper {
      border: 2px solid #d3f0f5;
      -webkit-border-radius: 85px;
      -moz-border-radius: 85px;
      border-radius: 85px;
      overflow: hidden;
      padding: 10px;
      height: 85px;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      justify-content: space-between;
      vertical-align: middle;
      align-items: center;
      max-width: rem(220px);
      margin: 0 auto;
    }
    &-progress {
      float: left;
      width: 64px;
      height: 64px;
      position: relative;
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 64px;
        height: 64px;
        background: url(../../assets/img/badges/under.svg) no-repeat center;
        background-size: 42px 42px;
        z-index: 1;
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 64px;
        height: 64px;
        background: url(../../assets/img/badges/over.svg) no-repeat center;
        background-size: 64px 64px;
        z-index: 3;
      }
    }
    &-text {
      width: 110px;
      float: right;
      margin-right: 10px;
    }
  }
  .logo {
    width: 110px;
    height: 15px;
    display: inline-block;
    background: url(../../assets/img/badges/logo.svg) no-repeat center;
    background-size: 110px 15px;
    margin-bottom: 5px;
  }
  .level {
    line-height: 18px;
    font-size: 12px;
    font-family: font('openSans'), sans-serif;
    background: #7fdce8;
    font-weight: 600;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    text-align: center;
    display: block;
    margin: 0 auto;
    max-width: 110px;
  }
  #progress {
    z-index: 2;
    position: relative;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .progress__meter,
  .progress__value {
    fill: none;
  }
  .progress__meter {
    stroke: #d1edf3;
  }
  .progress__value {
    display: none;
    stroke: #00bbd1;
    &-ft {
      -webkit-transform-origin: 50% 50%;
      -moz-transform-origin: 50% 50%;
      -ms-transform-origin: 50% 50%;
      -o-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    &-pp {
      -webkit-transform-origin: 50% 50%;
      -moz-transform-origin: 50% 50%;
      -ms-transform-origin: 50% 50%;
      -o-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -o-transform: rotate(90deg);
      transform: rotate(90deg);
    }
    &-at {
      -webkit-transform-origin: 50% 50%;
      -moz-transform-origin: 50% 50%;
      -ms-transform-origin: 50% 50%;
      -o-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
    }
    &-rt {
      -webkit-transform-origin: 50% 50%;
      -moz-transform-origin: 50% 50%;
      -ms-transform-origin: 50% 50%;
      -o-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
      -webkit-transform: rotate(270deg);
      -moz-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
      -o-transform: rotate(270deg);
      transform: rotate(270deg);
    }
  }
  .company-badge {
    &.dark {
      .badge {
        &-wrapper {
          border-color: #faf845;
        }
        &-progress {
          &:before {
            opacity: 0.5;
            background: url(../../assets/img/badges/under-yellow.svg) no-repeat center;
            background-size: 42px 42px;
          }
          &:after {
            background: url(../../assets/img/badges/over-yellow.svg) no-repeat center;
            background-size: 64px 64px;
          }
        }
      }
      .logo {
        background: url(../../assets/img/badges/logo-hightcontrast.svg) no-repeat center;
        background-size: 110px 15px;
      }
      .level {
        background-color: #faf845 !important;
        color: #000;
      }
      .progress__meter {
        stroke: #faf845;
        opacity: 0.2;
      }
      .progress__value {
        stroke: #faf845;
      }
    }
  }
</style>

<style lang="scss">
  body.hide-cookie-accept {
    #cookiescript_badge,
    #cookiescript_injected {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// Badge.vue?3c1cc258